export const showConsentDetails = (serviceId) => {
    var _a;
    (_a = window.UC_UI) === null || _a === void 0 ? void 0 : _a.showSecondLayer(serviceId);
    return false;
};
window.showConsentDetails = showConsentDetails;
document.addEventListener("DOMContentLoaded", () => {
    var _a;
    if (window.siteaccess) {
        (_a = window.UC_UI) === null || _a === void 0 ? void 0 : _a.updateLanguage(window.siteaccess);
    }
    // Footer handling
    // Check for links in the footer with a href of "#privacy-settings".
    // Hijack the click event and open the usercentrics dialog instead.
    const footer = document.querySelector("footer");
    if (!footer) {
        return;
    }
    const links = footer.querySelectorAll('a[href="#privacy-settings"]');
    links.forEach((link) => {
        link.addEventListener("click", (event) => {
            event.preventDefault();
            showConsentDetails();
        });
    });
});
